module.exports = __webpack_public_path__ + "img/warning_color.f445342f.svg";